import { useRegisterSW } from 'virtual:pwa-register/react';
import { useTranslation } from 'react-i18next';
import { RefreshCw, X } from 'lucide-react';

export default function UpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.warn('SW registration failed, clearing stale caches:', error);
      if ('caches' in window) {
        caches.keys().then(names =>
          names.forEach(name => caches.delete(name))
        );
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-50 bg-surface-0 border border-surface-400/15 shadow-elevated rounded-xl p-4 flex items-center gap-3">
      <RefreshCw size={20} className="text-primary-600 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-surface-800">{t('pwa.updateAvailable')}</p>
      </div>
      <button
        onClick={() => updateServiceWorker(true)}
        className="btn btn-primary text-xs py-1.5 px-3 flex-shrink-0"
      >
        {t('pwa.update')}
      </button>
      <button
        onClick={() => setNeedRefresh(false)}
        className="text-surface-400 hover:text-surface-600 flex-shrink-0"
        aria-label={t('pwa.dismiss')}
      >
        <X size={16} />
      </button>
    </div>
  );
}
